import { isDev } from '@/utils/common';

import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Report: AppRouteRecordRaw = {
  path: '/report',
  name: 'Report',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '报表分析',
    requiresAuth: true,
    icon: 'icon-bar-chart',
    order: 6,
  },
  children: [
    {
      path: 'allprocess-detail-report',
      name: 'AllprocessDetailReport',
      component: () =>
        import('@/views/report/allprocessDetailReport/index.vue'),
      meta: {
        title: '生产明细',
        requiresAuth: true,
        roles: ['completeFlowReportGet'],
        menuIcon: 'icon-shengchanmingxi',
      },
    },
    {
      path: 'production-report',
      name: 'ProductionReport',
      component: () => import('@/views/report/production/index.vue'),
      meta: {
        title: '生产报表',
        requiresAuth: true,
        roles: ['produceStatisticsGet'],
        menuIcon: 'icon-shengchanbaobiao',
      },
    },
    {
      path: 'produce-cost-report',
      name: 'ProduceCostReport',
      component: () => import('@/views/report/produceCostReport/index.vue'),
      meta: {
        title: '生产成本报表',
        requiresAuth: true,
        roles: ['goodsCostPriceReportGet'],
        menuIcon: 'icon-shengchanchengbenbaobiao',
      },
    },
    {
      path: 'same-colorcode-summary',
      name: 'SameColorCodeSummary',
      component: () => import('@/views/report/sameColorCodeSummary/index.vue'),
      meta: {
        title: '同款色码汇总',
        requiresAuth: true,
        roles: ['colorSizeStatisticsGet'],
        menuIcon: 'icon-tongkuansemahuizong',
      },
    },
    {
      path: 'finished-in-report',
      name: 'FinishedInReport',
      component: () => import('@/views/report/finished-in-report/index.vue'),
      meta: {
        title: '成品入库报表',
        requiresAuth: true,
        roles: ['goodsStoreInStaticsGet'],
        menuIcon: 'icon-chengpinrukubaobiao',
      },
    },
    {
      path: 'out-days-reprot',
      name: 'OutDaysReport',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '出货分析报表',
        requiresAuth: true,
        roles: ['produceOutStatisticsGet'],
        amisAppId: isDev() ? '21352737' : '05fd89e3',
        menuIcon: 'icon-gongchangchuhuofenxi',
      },
    },
    {
      path: 'production-monitoring-screen',
      name: 'ProductionMonitoringScreen',
      component: () =>
        import('@/views/production/productionMonitoringScreen/index.vue'),
      meta: {
        title: '生产监控大屏',
        requiresAuth: true,
        roles: ['produceMonitorScreenGet'],
        menuIcon: 'icon-shengchanjiankongdaping',
      },
    },
    {
      path: 'edition-workprocess-report',
      name: 'EditionWorkprocessReport',
      component: () =>
        import('@/views/report/editionWorkprocessReport/index.vue'),
      meta: {
        title: '版单工序报表',
        requiresAuth: true,
        roles: ['designNodeReportStatisticsGet'],
        flagShip: true,
        menuIcon: 'icon-bandangongxubaobiao',
      },
    },
    {
      path: 'outsource-report',
      name: 'OutsourceReport',
      component: () => import('@/views/report/outsourceReport/index.vue'),
      meta: {
        title: '外发回收报表',
        requiresAuth: true,
        roles: ['outWardStaticsGet'],
        menuIcon: 'icon-waifahuishoubaobiao',
      },
    },
    {
      path: 'production-workprocess-report',
      name: 'ProductionWorkprocessReport',
      component: () =>
        import('@/views/report/productionWorkprocessReport/index.vue'),
      meta: {
        title: '生产工序报表',
        requiresAuth: true,
        roles: ['produceWorkProcessReportStatisticsGet'],
        menuIcon: 'icon-shengchangongxubaobiao',
      },
    },
    {
      path: 'material-transfer-report',
      name: 'MaterialTransferReport',
      component: () =>
        import('@/views/material/materialTransferReport/index.vue'),
      meta: {
        title: '物料调拨报表',
        requiresAuth: true,
        roles: ['materialTransferStatisticsGet'],
        menuIcon: 'icon-wuliaotiaobobaobiao',
      },
    },
    {
      path: 'purchase-report',
      name: 'PurchaseReport',
      component: () => import('@/views/production/purchaseReport/index.vue'),
      meta: {
        title: '生产采购报表',
        requiresAuth: true,
        roles: ['purchaseProcessStatistics', 'purchaseProcessStatisticsGet'],
        menuIcon: 'icon-shengchancaigoubaobiao',
      },
    },
    {
      path: 'material-purchase-report',
      name: 'MaterialPurchaseReport',
      component: () =>
        import('@/views/report/materialPurchaseReport/index.vue'),
      meta: {
        title: '物料采购报表',
        requiresAuth: true,
        roles: ['materialPurchaseStatisticsGet'],
        menuIcon: 'icon-wuliaocaigoubaobiao',
      },
    },
    {
      path: 'material-picking-report',
      name: 'MaterialPickingReport',
      component: () => import('@/views/report/materialPickingReport/index.vue'),
      meta: {
        title: '物料领料报表',
        requiresAuth: true,
        roles: ['materialPickReportGet'],
        menuIcon: 'icon-wuliaolingliaobaobiao',
      },
    },
    {
      path: 'material-in-report',
      name: 'MaterialInReport',
      component: () => import('@/views/report/material-in-report/index.vue'),
      meta: {
        title: '物料入库报表',
        requiresAuth: true,
        roles: ['materialStoreInReportGet'],
        menuIcon: 'icon-wuliaorukubaobiao',
      },
    },
    {
      path: 'material-out-report',
      name: 'MaterialOutReport',
      component: () => import('@/views/report/material-out-report/index.vue'),
      meta: {
        title: '物料出库报表',
        requiresAuth: true,
        roles: ['materialStoreOutReportGet'],
        menuIcon: 'icon-wuliaochukubaobiao',
      },
    },
    {
      path: 'finance-report',
      name: 'FinanceReport',
      component: () => import('@/views/report/financeReport/index.vue'),
      meta: {
        title: '财务报表',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['*'],
      },
    },
    {
      path: 'ticket-report',
      name: 'TicketReport',
      component: () => import('@/views/report/ticketReport/index.vue'),
      meta: {
        title: '菲票统计',
        requiresAuth: true,
        roles: ['scanTicketStatisticsGet'],
        menuIcon: 'icon-feipiaotongji',
      },
    },
    {
      path: 'inspection-statistics',
      name: 'InspectionStatistics',
      component: () => import('@/views/report/inspectionStatistics/index.vue'),
      meta: {
        title: '质检统计',
        requiresAuth: true,
        roles: ['inspectionStatisticsGet'],
        menuIcon: 'icon-zhijiantongji',
      },
    },
    {
      path: 'paper-sample-statistics',
      name: 'PaperSampleStatistics',
      component: () => import('@/views/report/paperSampleStatistics/index.vue'),
      meta: {
        title: '纸样统计',
        requiresAuth: true,
        roles: ['statisticsPaperGet'],
        menuIcon: 'icon-zhiyangtongji',
      },
    },
  ],
};

export default Report;
